import { jsPDF } from "jspdf";
import { GeneratedComplaint } from "../types";

export const generatePDF = (
  complaint: GeneratedComplaint, 
  companyName: string,
  imageData?: string | null, // base64 string
  imageMime?: string
) => {
  const doc = new jsPDF();
  
  const margin = 20;
  const pageWidth = doc.internal.pageSize.getWidth();
  const maxLineWidth = pageWidth - margin * 2;
  
  let cursorY = 20;

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(`Complaint to ${companyName}`, margin, cursorY);
  cursorY += 15;

  // Subject
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  const subjectPrefix = "Subject: ";
  doc.text(`${subjectPrefix}${complaint.subject}`, margin, cursorY, { maxWidth: maxLineWidth });
  
  // Estimate height of subject lines
  const subjectLines = doc.splitTextToSize(`${subjectPrefix}${complaint.subject}`, maxLineWidth);
  cursorY += (subjectLines.length * 7) + 10;

  // Body
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  const bodyLines = doc.splitTextToSize(complaint.body, maxLineWidth);
  
  doc.text(bodyLines, margin, cursorY);
  
  // Calculate where text ends
  cursorY += (bodyLines.length * 7) + 10;

  // Image (if provided)
  if (imageData && imageMime) {
    // Check if we need a new page
    // We assume an image height of roughly 100 units
    if (cursorY > doc.internal.pageSize.getHeight() - 110) {
      doc.addPage();
      cursorY = 20;
    }

    doc.setFont("helvetica", "italic");
    doc.text("Attached Evidence:", margin, cursorY);
    cursorY += 10;

    // Constrain image size
    const maxWidth = 120;
    const maxHeight = 100;
    
    // We pass the format string based on mime type, e.g., 'JPEG' or 'PNG'
    // Default to JPEG if unknown
    let format = 'JPEG';
    if (imageMime.toLowerCase().includes('png')) format = 'PNG';
    else if (imageMime.toLowerCase().includes('webp')) format = 'WEBP';

    try {
        doc.addImage(imageData, format, margin, cursorY, maxWidth, maxHeight);
    } catch (e) {
        console.error("Error adding image to PDF", e);
        doc.setTextColor(255, 0, 0);
        doc.text("[Image could not be rendered]", margin, cursorY);
    }
  }

  // Clean company name for filename
  const safeName = companyName.replace(/[^a-z0-9]/gi, '_').substring(0, 20);
  doc.save(`${safeName}_Complaint.pdf`);
};